import { ComponentProps } from "react";

const FilterIcon = (props: ComponentProps<"svg">) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="-5 0 394 394" {...props}>
    <path d="M367.82 0H16.56A16.502 16.502 0 0 0 1.848 8.96a16.732 16.732 0 0 0 1.3 17.415L131.836 207.66c.043.063.09.121.133.184a36.751 36.751 0 0 1 7.219 21.816v147.8a16.448 16.448 0 0 0 4.773 11.688A16.45 16.45 0 0 0 155.617 394a16.94 16.94 0 0 0 6.48-1.3l72.313-27.571c6.477-1.98 10.778-8.094 10.778-15.453V229.66a36.774 36.774 0 0 1 7.214-21.816c.043-.063.09-.121.133-.184L381.227 26.371a16.717 16.717 0 0 0 1.3-17.406A16.492 16.492 0 0 0 367.82 0zm0 0" />
  </svg>
);

export default FilterIcon;
